import { useQuery } from '@apollo/client'
import { getPublicFeatureToggles } from 'api/queries/public-feature-toggles'

type PublicFeatureToggles = {
  comboRedirects: boolean
}

type PublicFeatureTogglesResponse = {
  publicFeatureToggles: PublicFeatureToggles
}

export const usePublicFeatureToggles = () => {
  const { data, loading, error } = useQuery<PublicFeatureTogglesResponse>(
    getPublicFeatureToggles,
    {
      fetchPolicy: 'cache-first',
      errorPolicy: 'ignore'
    }
  )

  const comboRedirects = data?.publicFeatureToggles?.comboRedirects

  return {
    comboRedirects,
    loading,
    error
  }
}
